import { render, staticRenderFns } from "./UserLayer.vue?vue&type=template&id=b6077c7a&"
import script from "./UserLayer.vue?vue&type=script&lang=js&"
export * from "./UserLayer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports